import React from 'react';
import Icon from '../../../components/AppIcon';

const WeatherWidget = ({ weather }) => {
  const weatherIcons = {
    sunny: 'Sun',
    cloudy: 'Cloud',
    rainy: 'CloudRain',
    stormy: 'CloudLightning',
    windy: 'Wind'
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-card-foreground font-semibold text-lg">Current Weather</h3>
        <Icon name="RefreshCw" size={20} className="text-muted-foreground cursor-pointer hover:text-card-foreground animation-organic" />
      </div>
      <div className="flex items-center gap-6 mb-6">
        <div className="text-accent">
          <Icon name={weatherIcons?.[weather?.condition] || 'Cloud'} size={64} />
        </div>
        <div>
          <div className="text-5xl font-bold text-card-foreground">{weather?.temperature}°C</div>
          <div className="text-muted-foreground capitalize">{weather?.condition}</div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-center gap-2">
          <Icon name="Droplets" size={20} className="text-info" />
          <div>
            <div className="text-xs text-muted-foreground">Humidity</div>
            <div className="text-card-foreground font-medium">{weather?.humidity}%</div>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <Icon name="Wind" size={20} className="text-info" />
          <div>
            <div className="text-xs text-muted-foreground">Wind Speed</div>
            <div className="text-card-foreground font-medium">{weather?.windSpeed} km/h</div>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <Icon name="Eye" size={20} className="text-info" />
          <div>
            <div className="text-xs text-muted-foreground">Visibility</div>
            <div className="text-card-foreground font-medium">{weather?.visibility} km</div>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <Icon name="Gauge" size={20} className="text-info" />
          <div>
            <div className="text-xs text-muted-foreground">Pressure</div>
            <div className="text-card-foreground font-medium">{weather?.pressure} hPa</div>
          </div>
        </div>
      </div>
      {weather?.alerts && weather?.alerts?.length > 0 && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center gap-2 text-warning">
            <Icon name="AlertTriangle" size={16} />
            <span className="text-sm font-medium">Weather Alert Active</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default WeatherWidget;